import Home from "./home/Home";
import About from "./about/About";
import Experience from "./experience/Experience";
import Photography from "./photography/Photography";
import React from 'react';
import { Route, Routes } from 'react-router-dom';

export default function MultiPageRoutes() {
    return (
        <Routes>
            <Route exact path={'/'} element={<Home />} />
            <Route exact path={'/about'} element={<About />} />
            <Route exact path={'/experience'} element={<Experience />} />
            <Route exact path={'/photography'} element={<Photography />} />
        </Routes>
    )
}
